<template>
  <div class="theLoginBackground">
    <div id="layout">
      <div id="north"></div>
      <div id="menu"></div>
      <div id="center">
        <div id="content" class="content">
          <!--登录-->
          <div class="nav">
            <div class="logo"><a href="/" class="loginLogo"></a></div>
          </div>
          <div id="login_banner"></div>
          <div class="login" id="state_login">
            <div class="login_title">
              虚拟仿真实验项目共享平台-登录
            </div>
            <div class="login_title_mobile hide">账号登录</div>
            <div class="tab hide">
              <span class="tab-item on">账号密码登录</span
              ><span class="tab-item">短信验证码登录</span>
            </div>
            <form class="login_form" id="loginForm" onsubmit="return false;">
              <div class="password-login">
                <div class="login_item">
                  <i class="iconfont ipt-icon"></i
                  ><input
                    class="ipt"
                    id="user"
                    type="text"
                    autocomplete="off"
                    name="phone"
                    placeholder="手机号/用户名"
                    required="true"
                    autofocus="true"
                    v-model="theLoginRequest.username"
                  />
                </div>
                <div class="login_item">
                  <i class="iconfont ipt-icon"></i
                  ><input
                    class="ipt"
                    id="password"
                    type="password"
                    autocomplete="new-password"
                    name="password"
                    placeholder="密码"
                    required="true"
                    v-model="theLoginRequest.password"
                  />
                </div>
                <div class="login_item item-verify hide" style="display: block">
                  <i class="iconfont ipt-icon"></i
                  ><input
                    class="ipt verify"
                    type="text"
                    autocomplete="off"
                    name="verify"
                    placeholder="验证码"
                    required="true"
                    v-model="theLoginRequest.code"
                    @keyup.enter="clickLogin()"
                  /><span class="verify-code" title="看不清，换一个"
                    ><img
                      alt="载入中..."
                      :src="captchaImage"
                      @click="getVerificationCodeRequests()"
                      style="
                        text-align: center;
                        line-height: 43px;
                        margin: 0 auto;
                      "
                  /></span>
                </div>
              </div>
              <div class="sms-login hide">
                <div class="login_item">
                  <i class="iconfont ipt-icon"></i
                  ><input
                    class="ipt"
                    type="text"
                    autocomplete="off"
                    name="phone2"
                    placeholder="手机号"
                    required="true"
                    autofocus="true"
                  />
                </div>
                <div class="login_item phone-reg short-ipt">
                  <i class="iconfont ipt-icon"></i
                  ><input
                    class="ipt"
                    type="text"
                    name="captcha"
                    placeholder="输入图形验证码"
                  />
                  <div class="captcha-ctn">
                    <div class="captcha-img">
                      <img
                        src="data:image/jpeg;base64,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"
                      />
                    </div>
                    <span class="reload-btn" id="reloadCaptcha"
                      ><div class="reload-bg"></div>
                      <span class="reload-txt"
                        >换一张<i class="iconfont"></i></span
                      ></span
                    >
                  </div>
                </div>
                <div class="login_item short-ipt">
                  <i class="iconfont ipt-icon"></i
                  ><input
                    class="ipt"
                    type="text"
                    name="code"
                    autocomplete="off"
                    placeholder="输入短信验证码"
                  /><span class="code" id="sms-code">获取验证码</span>
                </div>
              </div>
            </form>
            <div class="login_btn" @click="clickLogin()">立即登录</div>
            <div class="login_remenber_box clearfix">
              <div class="login_resigter">
                <router-link to="/mylogin">注册</router-link>
              </div>
              <div class="login_remenber">
                <router-link to="/forgotPassword">忘记密码 ?</router-link>
           
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="south">
        <div id="footer"></div>
      </div>
    </div>
    <div id="dialog_overlay" style="visibility: hidden">
      <div id="dialog_bg"></div>
      <div id="dialog_panel">
        <div id="dialog_panel_bg"></div>
        <div id="dialog_title">提示</div>
        <div id="dialog_content"></div>
        <div id="dialog_control">
          <a
            href="javascript:void(0)"
            id="dialog_close"
            class="button"
            style="display: none"
            >取消</a
          ><a href="javascript:void(0)" id="dialog_ok" class="button">确认</a>
        </div>
      </div>
    </div>
    <div id="page-loading" style="display: none"></div>
    <a href="#" id="toTop" style="display: none"
      ><span id="toTopHover"></span><i class="move-to-up iconfont"></i></a
    >
    <div id="udesk_container">
      <div id="udesk_btn">
        <a
          class="udesk-client-btn"
          style="
            display: block;
            position: fixed;
            box-sizing: border-box;
            font-size: 13px;
            color: rgb(255, 255, 255);
            text-align: center;
            cursor: pointer;
            text-decoration: none;
            z-index: 1000000000;
            border-color: rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.1) currentcolor;
            border-style: solid solid none;
            border-width: 1px 1px 0px;
            border-image: none 100% / 1 / 0 stretch;
            background-color: rgb(48, 122, 232);
            height: 40px;
            width: 100%;
            right: 0px;
            bottom: 0px;
            margin: 3px 30px;
          "
          ><span
            style="
              display: block;
              float: left;
              width: 24px;
              height: 24px;
              margin: 7px 7px 0;
            "
            ><img
              src="http://static-ud.udesk.cn/img/msg2@68x66.png"
              style="width: 100%; height: 100%" /></span
          ><span
            style="
              display: block;
              float: left;
              width: 1px;
              height: 100%;
              background-color: rgba(0, 0, 0, 0.08);
              vertical-align: middle;
              background-color: #000\9;
              filter: alpha(opacity=10) \9;
            "
          ></span
          ><span
            id="udesk_btn_text"
            style="
              display: block;
              float: none;
              height: 40px;
              margin: 0 10px;
              line-height: 40px;
              overflow-y: hidden;
              font-size: 13px;
              color: #fff;
            "
            >在线咨询</span
          ><span
            id="udesk_btn_circle"
            style="
              display: none;
              position: absolute;
              top: -13px;
              right: -13px;
              width: 26px;
              height: 26px;
              text-align: center;
              line-height: 26px;
              font-size: 14px;
              color: #fff;
              border-radius: 15px;
              background-color: #ff3b30;
            "
          ></span
        ></a>
      </div>
      <div id="udesk_panel">
        <iframe
          id="udesk_iframe"
          scrolling="no"
          allowtransparency="true"
          style="
            width: 1px;
            min-width: 100%;
            *width: 100%;
            height: 0;
            border: none;
            padding: 0;
            margin: 0;
            float: none;
            background: none;
            transition: height 0.1s;
            -webkit-transition: height 0.1s;
            -moz-transition: height 0.1s;
            -ms-transition: height 0.1s;
            -o-transition: height 0.1s;
          "
          allowfullscreen=""
          mozallowfullscreen=""
          webkitallowfullscreen=""
          frameborder="0"
        ></iframe>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, reactive } from "vue";
import { theLogin, getVerificationCode } from "../assets/api/index";
import router from "../router/index.js";
import { ElMessage } from "element-plus";
export default {
  setup() {
    const tableData = ref([]);
    const captchaImage = ref([]);

    const theLoginRequest = reactive({
      code: "",
      password: "",
      username: "",
      uuid: "",
    });
    const getData = () => {
      theLogin(theLoginRequest).then((res) => {
        tableData.value = res;
      });
    };

    const getVerificationCodeRequests = () => {
      getVerificationCode(theLoginRequest).then((res) => {
        captchaImage.value = "data:image/jpeg;base64," + res.img;
        theLoginRequest.uuid = res.uuid;
      });
    };
    getVerificationCodeRequests();

    const clickLogin = () => {
      theLogin(theLoginRequest).then((res) => {
        if (res.code == 500) {
          ElMessage.error(res.msg);
          getVerificationCodeRequests();
        } else {
          ElMessage.success(res.msg);
          localStorage.setItem("token", res.token);
          localStorage.setItem("whetherTheLogin", "1");
          router.push("/teachersPersonalCenter");
        }
      });
    };

    return {
      tableData,
      theLoginRequest,
      captchaImage,
      getVerificationCodeRequests,
      clickLogin,
      getData,
    };
  },

  name: "registered",
};
</script>

<style src="../assets/css/login1.css"  scoped></style>
<style src="../assets/css/login2.css"  scoped></style>
<style>
.theLoginBackground {
  height: 100%;
  background: url("../assets/image/bigbg.jpg") no-repeat;
  background-size: auto;
  background-size: cover;
}
.loginLogo {
  background: url(../assets/image/logobaise.png) no-repeat center center !important;
}
</style>